async function getCpt(param) {
  const response = await fetch(
    'https://smile.fastdev.pl' + '/wp-json/wp/v2/' + param
  );
  console.log('https://smile.fastdev.pl' + '/wp-json/wp/v2/' + param);
  return await response.json();
}

export default getCpt;
